<template>
    <div class="partner-listing-add">
        <br/><br/><br/><br/>
        <div class="align-self-center text-center">
            <h1>Redirecting to requested page..</h1>
        </div>
        <div class="spinner-container d-flex justify-content-center">
            <b-spinner id="spinner" variant="primary" label="Redirecting to requested page..."></b-spinner>
        </div>
    </div>
</template>

<script>
import {appPageRedirect, paramsToQueryString} from "@helpers/router-helper";
import SetupEngineAxiosMixin from "@packages/integrations/mixins/SetupEngineAxiosMixin";
import OrderByExternalIdMixin from "@packages/integrations/mixins/OrderByExternalIdMixin";
import FormErrorsMixin from "@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin";

export default {
    name: "PartnerListingAdd",

    mixins: [
        FormErrorsMixin,
        SetupEngineAxiosMixin,
        OrderByExternalIdMixin,
    ],

    data: () => ({
        loading: false,
        orderAppResourceUuid: null,
    }),

    async created() {
        let params = await this.getParamsAndCheckExistence();

        //lonewolf sends the user incorrectly to this page from an existing disclosure page;
        if (this.orderAppResourceUuid) {
            await appPageRedirect(
                'agent',
                this.agentOwnsOrder ? `/orders/${this.orderAppResourceUuid}/details` : '/dashboard'
            );
        } else {
            await appPageRedirect(
                'agent',
                !params.developerListingId || (!!params.address || confirm("This property was not found in your disclosures list. Would you like to create a new disclosure for it?"))
                    ? '/invite-seller?' + paramsToQueryString(params)
                    : `/dashboard`
            );
        }
    },
}
</script>